import { useTranslation } from 'react-i18next'
import MarkdownRenderer from 'src/components/ui/MarkdownRenderer'
import { UIDialog } from 'src/components/ui/Modal'
import { track } from 'src/utils/tracker'
import IcBaselineOpenInNew from '~icons/ic/baseline-open-in-new'
import IconParkOutlineClose from '~icons/icon-park-outline/close'

function NotificationNewsPreviewModalContent(props: {
  item: { id?: string; content?: string; title?: string }
  onClose?: () => void
}) {
  const { t } = useTranslation(['action'])
  const { item } = props

  return (
    // same max-w as prose
    <div className="p-4 min-w-[320px] max-w-[650px]">
      <div className="flex flex-col w-full">
        <header className="mb-4 flex items-start gap-3 pb-4 border-b border-card-border">
          <div className="flex-1 flex flex-col gap-3">
            <h1 className="font-bold text-2xl">{item.title}</h1>
            {item.id && (
              <a
                href={`/news/${item.id}`}
                target="_blank"
                className="inline-flex items-center gap-1 whitespace-nowrap text-sm text-theme-primary"
                onClick={() => track('news_open_new_window_click')}
                rel="noreferrer"
              >
                <IcBaselineOpenInNew className="flex-none size-5" />
                {t('action:open-in-new-window')}
              </a>
            )}
          </div>
          {props.onClose && (
            <button className="flex-none" onClick={props.onClose}>
              <IconParkOutlineClose className="size-6" />
            </button>
          )}
        </header>
        <MarkdownRenderer as="p" className="prose dark:prose-invert p-2">
          {item.content ?? ''}
        </MarkdownRenderer>
      </div>
    </div>
  )
}

export function openNotificationNewsModal(item: {
  id?: string
  content?: string
  title?: string
}) {
  UIDialog.create({
    dismissable: true,
    className: 'w-fit max-w-none',
    children: ({ close }) => (
      <NotificationNewsPreviewModalContent item={item} onClose={close} />
    ),
  })
}
